import { CommonModule, NgClass }                                           from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule }                                                 from '@angular/material/button';
import { MatIconModule }                                                   from '@angular/material/icon';
import { PushPipe }                                                        from '@ngrx/component';
import { deepCopy }                                                        from '@shared/helper/LDHelper';
import { CarouselModule }                                                  from 'ngx-owl-carousel-o';
import { Observable }                                                      from 'rxjs';
import { ImagePipe }                                                       from 'src/app/shared/pipe/image.pipe';
import { Tile }                                                            from './tile';

interface IOwlCarouselOptions {
  loop: boolean;
  mouseDrag: boolean;
  touchDrag: boolean;
  autoWidth: boolean;
  pullDrag: boolean;
  dots: boolean;
  dotsEach: number | boolean;
  dotsData: boolean;
  // navSpeed: number;
  margin: number;
  responsive: any;
}

const OWL_CAROUSSEL_OPTIONS = {
  loop:      true,
  mouseDrag: true,
  touchDrag: true,
  autoWidth: true,
  pullDrag:  true,
  dots:      true,
  dotsEach:  true,
  dotsData:  true,
  // navSpeed : 700,
  margin: 20,
  // nav:            true,
  // navText:        ["<span class='material-icons'>arrow_back_ios</span>", "<span class='material-icons'>arrow_forward_ios</span>"],
  // navigation:     true,
  responsive: {
    0:   {
      items: 2,
    },
    768: {
      items: 4,
    },
  },

};


@Component ({
              selector:        'app-tile',
              templateUrl:     './tile.component.html',
              styleUrls:       ['./tile.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports:         [
                MatButtonModule,
                MatIconModule,
                CarouselModule,
                PushPipe,
                NgClass,
                ImagePipe,
                CommonModule,
              ],
              providers:       [],
            })
export class TileComponent {
  @Input () tile$: Observable<Tile[]>;
  @Output () onSelectTile: EventEmitter<Tile>;

  public options: IOwlCarouselOptions;

  constructor () {
    this.onSelectTile = new EventEmitter<Tile> ();
    this.options      = OWL_CAROUSSEL_OPTIONS;
  }

  onClick (tile: Tile) {
    const tileSelected    = deepCopy(tile);
    tileSelected.selected = true;
    this.onSelectTile.next (tile);
  }


  trackById (index, item: Tile) {
    return item.id;
  }
}
